/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Bühler
 * Date: 12.02.2016
 *
 */


'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AppContext, ContextContainer, DataLinkContainer, ValidationMessage, DataUtil } from 'plugin/liferay-widgets-react-web';
import { FormLabel, FormControl, FormGroup, Row, Col, Button } from 'external/react-bootstrap';

import AssetTagActions from '../actions/AssetTagActions';
import DlFileEntryActions from '../actions/DlFileEntryActions';
import AttachedDocumentList from './AttachedDocumentList';
import { getAssetTagStore, getDLFileEntryStore } from '../stores/StoreFactory';

const AssetTagStore = getAssetTagStore(AppContext);

const AttachedDocumentListLink = DataLinkContainer.link(AttachedDocumentList, 'list', getDLFileEntryStore(AppContext));

class AttachedDocumentsByTagForm extends React.Component {

    constructor(props) {
        super(props);

        this.DATA = {
            ASSET_TAGS: this.withCtx('ASSET_TAGS'),
            DOCUMENTS_BY_TAGS: this.withCtx('DOCUMENT_BY_TAG')
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        AssetTagActions.getAssetTagsByGroupId(this.DATA.ASSET_TAGS, {
            groupId: AppContext.getScopeGroupId()
        });

    }

    static getStores() {
        return [
            AssetTagStore
        ];
    }

    static calculateState(prevState, prevProps, DATA) {
        return {
            tagDataList: AssetTagStore.getRemoteData(DATA.ASSET_TAGS),
        };
    }

    withCtx(s) {
        return this.props.formId + '.' + s;
    }

    onChange(e) {
        const tagId = parseInt(e.target.value);
        const formData = { ...this.props.formData, ...{ tagId } };
        this.props.onChange(formData, this.validate(formData));
        DlFileEntryActions.getGroupFileEntriesByTag(this.DATA.DOCUMENTS_BY_TAGS, { tagId });
    }

    onSubmit() {
        // eslint-disable-next-line react/prop-types
        this.props.submit();
    }


    validate(formData) {
        let tagIdValid;

        if (formData.tagId <= 0) {
            tagIdValid = 'Bitte Tag auswählen.';
        }

        return {
            tagId: tagIdValid
        };
    }

    render() {
        let { formData, formValidation, formValid } = this.props;

        let tagOptions = [];
        tagOptions.push(<option key={'Asset_Tag_' + -1} value={-1}>Bitte Tag auswählen!</option>);

        const { tagDataList } = this.state;

        if (tagDataList && DataUtil.asArray(tagDataList)) {
            const assetTags = DataUtil.asArray(tagDataList);
            assetTags.forEach(assetTag => {
                tagOptions.push(<option key={'Asset_Tag_' + assetTag.id} value={assetTag.id}>{assetTag.name}</option>);
            });
        }

        const buttonOptions = formValid ? {} : { disabled: 'disabled' };

        return (
            <fieldset>
                <Row>
                    <Col xs={12}>
                        <FormGroup controlId="WebcamWidgetImageUrl">
                            <FormLabel>
                                Dokumenten-Tag
                            </FormLabel>
                            <FormControl as="select"
                                         required
                                         value={formData.tagId}
                                         onChange={this.onChange}>
                                {tagOptions}
                            </FormControl>
                            <ValidationMessage formValidation={formValidation} propName="tagId"/>
                        </FormGroup>
                    </Col>
                </Row>
                {formData.tagId > 0 &&
                <React.Fragment>
                    <Row>
                        <Col xs={12}>
                            <hr/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <p>
                                Folgende Dokumente werden mit dem Objekt verbunden:
                            </p>
                            <AttachedDocumentListLink list={this.DATA.DOCUMENTS_BY_TAGS}
                                                  renderStyle={AttachedDocumentList.RENDER_STYLE.FLAT}/>
                        </Col>
                    </Row>
                </React.Fragment>
                }
            </fieldset>);
    }
}

AttachedDocumentsByTagForm.propTypes = {
    onChange: PropTypes.func,
    formValid: PropTypes.bool,
    formData: PropTypes.object,
    formValidation: PropTypes.object
};


export default ContextContainer.create(AttachedDocumentsByTagForm);




// WEBPACK FOOTER //
// ./js/components/AttachedDocumentsByTagForm.jsx